import {Vehicle} from '../types';

const CameraMisc = {
  vehicleHasActiveCameras: ( vehicle: Vehicle ) => {
    const {cams} = vehicle;
    for ( let i = 0, len = cams.length; i < len; i++ ) {
      const cam = cams[i];
      if ( cam.isActive ) {
        return true;
      }
    }
  },
  vehicleHasInactiveCameras: ( vehicle: Vehicle ) => {
    const {cams} = vehicle;
    for ( let i = 0, len = cams.length; i < len; i++ ) {
      const cam = cams[i];
      if ( !cam.isActive ) {
        return true;
      }
    }
  },
  getCameraStatusByVehicle: ( vehicle: Vehicle ) => {
    return {
      active: CameraMisc.vehicleHasActiveCameras( vehicle ),
      inactive: CameraMisc.vehicleHasInactiveCameras( vehicle )
    }
  }
}

export default CameraMisc;